<div class="custom-modal-body">
  <div class="wrapper">
    <div class="link" *ngFor="let item of listData">
      <a class="truncate" [title]="item.fileName" (click)="openLink(item)">{{item.fileName}}</a>
      <i nz-icon nzType="delete" nzTheme="outline" class="mx-2 cursor-pointer" *ngIf="needDelete" (click)="deleteFile(item)"></i>
    </div>
  </div>
  <div>
    <hr class="m-0 split-line" />
    <div class="c-modal-footer">
      <div class="content text-center">
        <button nz-button nzType="default" class="me-3 default-btn" type="button" (click)="closeModal()">Thoát</button>
        <button nz-button nzType="primary" class="button-submit" type="button" (click)="submit()" *ngIf="needDelete">Lưu</button>
        </div>
    </div>
  </div>
</div>
